import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../../axios.js";
import {
  DELETE_SUBSCRIBER,
  GET_MYACCOUNT_ADDRESS_SEARCH,
} from "../../../../Urls.js";

const initialState = {
  deleteFiberService: { data: [], loading: false, successMessage: "" },
  searchedAddreess: { data: [], loader: false },
};
export const searchAddr = createAsyncThunk(
  "app/get/searchAdd",
  async (addressOremailOrPhone) => {
    const resAccounts = await axios.get(
      GET_MYACCOUNT_ADDRESS_SEARCH + addressOremailOrPhone
    );
    return resAccounts;
  }
);
export const getPremiseDetails = createAsyncThunk(
  "premiseSlice/getPremiseDetails",
  async (premise_id) => {
    const response = await axios.get(
      `api/v1/premise/get-premise-service-point-details?premise_id=${premise_id}`
    );
    return response;
  }
);
export const getCaseAndOrderDetails = createAsyncThunk(
  "premiseSlice/getCaseAndOrderDetails",
  async (premise_id) => {
    const response = await axios.get(
      `api/v1/premise/get-case-and-order-no?premiseId=${premise_id}`
    );
    return response;
  }
);
export const getSmxOrderItemDetails = createAsyncThunk(
  "premiseSlice/getSmxOrderItemDetails",
  async (orderNumber) => {
    const response = await axios.get(
      `api/v1/premise/get-smx-order-items?orderNumber=${orderNumber}`
    );
    return response;
  }
);
export const getSmxTemplateMetadata = createAsyncThunk(
  "premiseSlice/getSmxTemplateMetadata",
  async ({ productCode, ontTemplate }) => {
    const response = await axios.get(
      `api/v1/premise/get-smx-template-metadata?productCode=${productCode}&ontTemplate=${ontTemplate}`
    );
    return response;
  }
);
export const fetchONTdetailsBySlNumber = createAsyncThunk(
  "premiseSlice/fetchONTdetailsBySlNumber",
  async (rg_fsan) => {
    const params = {
      oltId: "virtualOLT",
      // serialNumber: "CXNK00A99062" || rg_fsan,
      serialNumber: rg_fsan,
    };
    const response = await axios.get(
      "/api/v1/premise/ont-details-by-serial-number",
      { params }
    );
    return response;
  }
);

// used
export const updatePremiseServicePointDetails = createAsyncThunk(
  "premise/updatePremiseServicePointDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/v1/premise/update-premise-service-point-details",
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);
export const updatePremiseDetails = createAsyncThunk(
  "premise/updatePremiseDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/v1/premise/update-premise-details",
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);
export const updateOrderDetails = createAsyncThunk(
  "premise/updateOrderDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/v1/plans/update-order-details",
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);
export const updateCaseDetails = createAsyncThunk(
  "premise/updateCaseDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/api/v1/servicecase/update-case-details",
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { message: "Something went wrong" }
      );
    }
  }
);

export const deleteSubscriber = createAsyncThunk(
  "app/delete/deleteSubscriber",
  async (
    { subscriberid, subscriberserviceid, serviceReferenceNumber, oltId, ontId },
    { rejectWithValue }
  ) => {
    try {
      const url = `${DELETE_SUBSCRIBER}`;

      // build params dynamically, only include non-empty values
      const params = {
        deleteSubscriber: true,
        ...(subscriberid && { subscriberid }),
        ...(subscriberserviceid && { subscriberserviceid }),
        ...(serviceReferenceNumber && { serviceReferenceNumber }),
        ...(oltId && { oltId }),
        ...(ontId && { ontId }),
      };

      const response = await axios.delete(url, { params });
      return response.data;
    } catch (error) {
      // return rejectWithValue(error.response?.data || "Delete failed");
    }
  }
);

export const fiberEnrollmentIssueSlice = createSlice({
  name: "app/fiberEnrollmentIssueSlice",
  initialState,
  reducers: {
    selectedDocument: (state, action) => {
      state.selectedAnnucementItem = action?.payload;
    },
    clearSuccessMessage: (state) => {
      state.uploadDocument.successMessage = "";
      state.downloadDocumentData.successMessage = "";
      state.deleteFiberService.successMessage = "";
    },
  },

  extraReducers: (builder) => {
    builder

      .addCase(deleteSubscriber.pending, (state) => {
        state.deleteFiberService.loading = true;
      })
      .addCase(deleteSubscriber.fulfilled, (state, action) => {
        state.deleteFiberService.loading = false;
        state.deleteFiberService.data = action?.payload?.data?.data;
        state.deleteFiberService.successMessage =
          "Document deleted successfully!";
      })
      .addCase(deleteSubscriber.rejected, (state) => {
        state.deleteFiberService.loading = false;
        state.deleteFiberService.successMessage = "Failed to delete Document .";
      });
  },
});

export const { selectedDocument, clearSuccessMessage } =
  fiberEnrollmentIssueSlice.actions;

export default fiberEnrollmentIssueSlice.reducer;
